var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgets && _vm.layout)?_c('div',{ref:"layoutContainer",staticClass:"layout-main-container",style:({ backgroundColor: _vm.layout.settings.backgroundColor || '#FFFFFF' })},_vm._l((_vm.widgets),function(widget){return _c('Layer',{key:widget.assoc_id,attrs:{"widget":widget}})}),1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }